import axios from "../api/axiosInstance";

export const GetAllEmployee = async () => {
   return await axios.get("/Employee/GetEmployeeList");
};

export const AddEmployee = async (model) => {
  return await axios.post("/Employee/AddEmployee", model);
};

export const UpdateEmployee = async (model) => {
  return await axios.post("/Employee/UpdateEmployee", model);
};
export const GetEmployeeById = async (id) => {
  return await axios.get("/Employee/GetEmployeeById", {
    params: { id },
  });
};
